import { ref, computed, watchEffect } from "vue"
import FuncoesHelper from "@/helpers/FuncoesHelper";
import { useStore } from "@/store";
import StatusComponenteConstant from "@/constants/StatusComponenteConstant";

class ComponenteAssinaturaService {
    setup({ modulo }) {
        const store = useStore();
        const identificador = ref(FuncoesHelper.obterParametrosRota('identificador'));
        const statusResposta = ref(StatusComponenteConstant.PENDENTE.chave);
        const assinaturas = ref({});
        const modulos = computed(() => store.state.modulos);

        watchEffect(() => {
            if (modulos.value.length > 0) {
                const moduloAtual = modulos.value.find(module => module.idChecklistModulo == modulo);
                if (typeof moduloAtual != 'undefined') {
                    assinaturas.value = moduloAtual.assinaturas;
                    const { respostas, opcoes } = assinaturas.value || {};
                    if (respostas && Object.keys(opcoes).length === Object.keys(respostas).length) {
                        statusResposta.value = StatusComponenteConstant.PREENCHIDO.chave;
                    }
                }
            }
        });
        
        return { identificador, assinaturas, statusResposta };
    }

    detalheAssinaturaSetup() {
        const store = useStore();
        const identificador = ref(FuncoesHelper.obterParametrosRota('identificador'))
        const signatario = ref(FuncoesHelper.obterParametrosRota('signatario'))
        const localRealizacao = ref(FuncoesHelper.obterParametrosRota('localRealizacao'))
        const modulo = ref(FuncoesHelper.obterParametrosRota('modulo'))
        const nomeSignatario = ref('')
        const numeroDocumento = ref('')
        const larguraDaTela = ref(window.innerWidth * 0.8);
        const exibirLoader = ref(false)
        const exigeConfirmacao = ref(false)
        const confirmacaoSignatario = ref(false)
        const moduloAtual = computed(() => store.state.modulos.find(module => module.idChecklistModulo == modulo.value));
        const assinatura = computed(() => {
            return moduloAtual.value.assinaturas.opcoes[signatario.value];
        });
        
        if(assinatura.value.includes('responsável no local') && moduloAtual.value.ordem > 1) {
            exigeConfirmacao.value = true;
        }


        const configuracaoDrawingCanvas = ref({
            line: 3,
            color: "black",
            strokeType: "dash",
        });

        setTimeout(() => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }, 100)

        return {
            identificador,
            signatario,
            nomeSignatario,
            numeroDocumento,
            configuracaoDrawingCanvas,
            exibirLoader,
            larguraDaTela,
            localRealizacao,
            modulo,
            exigeConfirmacao,
            confirmacaoSignatario
        }
    }
}

export default new ComponenteAssinaturaService();